import React from 'react';
import styles from '@/app/ui/components/filters/filters.module.scss';
import { FilterOptionKeys, FilterOptionValue } from '@mybestbrands/types';
import { useTranslation } from 'next-i18next';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';

import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { safelyParseJSON } from '@/app/helpers/searchparams';
import { PriceFilterSkeleton } from '@/app/ui/components/skeletons/skeletons';

interface Props {
  isActive: boolean;
  filter: FilterOptionValue | undefined;
  onFilterUpdate: (value: string[] | number[] | number) => void;
  toggleFilterOptions: () => void;
  onApplySearchFilters: () => void;
}

const DynamicPriceFilterSlider = dynamic(() => import('@/app/ui/components/filters/PriceFilterSlider'), {
  ssr: false,
  loading: () => <PriceFilterSkeleton />,
});

const PriceFilter = (props: Props) => {
  const { t } = useTranslation('filters');

  const sp = useSearchParams();
  const filters = sp?.get('filters');
  const filtersParsed = safelyParseJSON(filters);

  const Chevron = props.isActive ? ChevronUp : ChevronDown;
  return (
    <div
      className="position-relative"
      style={{
        zIndex: 3,
      }}>
      <div
        onClick={props.toggleFilterOptions}
        key={FilterOptionKeys.PRICE}
        className={`btn btn-white-hover-black lowercase d-flex justify-content-center align-items-center ${styles.filter}`}>
        <span className="me-1">{t(FilterOptionKeys.PRICE)}</span>
        {!!filtersParsed.price && (
          <span className={`${styles.filtercounter}`}>
            <span className="position-relative" style={{ bottom: '1px' }}>
              {1}
            </span>
          </span>
        )}
        <Chevron className="ms-2" />
      </div>
      {props.isActive && (
        <div className={`position-absolute bg-white border border-dark p-2`} style={{ top: '35px' }}>
          <div className={` ${styles.sizescontainer} p-2`} style={{ paddingBottom: 1 }}>
            <DynamicPriceFilterSlider onFilterUpdate={props.onFilterUpdate} price={props.filter} />
          </div>
          <div className="position-relative">
            <button
              onClick={props.onApplySearchFilters}
              className="btn filter btn-white-hover-black lowercase mt-3 mb-2 w-100">
              {t('SAVE')}
              <span className="ms-1" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceFilter;
